/**
 * Route constants
 * All routes should be defined here to avoid hardcoded strings
 */

export const ROUTES = {
  HOME: '/',
  LANDING_PREVIEW: '/landing-preview',
  LOGIN: '/login',
  REGISTER: '/register',
  PHONE_LOGIN: '/login/phone',
  WHATSAPP_LOGIN: '/login/whatsapp',
  EMAIL_OTP_LOGIN: '/login/email-otp',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_PASSWORD_CHANGE: '/confirm-password-change',
  CONFIRM_PASSWORD_CREATION: '/confirm-password-creation',
  AUTHORIZE_EMAIL_CHANGE: '/authorize-email-change',
  CONFIRM_EMAIL_CHANGE: '/confirm-email-change',
  EMAIL_CONFIRMATION: '/verify-email',
  OAUTH_CALLBACK: '/auth/oauth/:provider/callback',
  PROFILE: '/profile',
  PROFILE_TAB: (tab: 'profile' | 'addresses' | 'security' | 'settings' | 'referrals') => 
    tab === 'profile' ? '/profile' : `/profile?tab=${tab}`,
  MY_ORDERS: '/my-orders',
  MY_PLAN: '/my-plan',
  MY_ORDER_DETAIL: (id: string) => `/my-orders/${id}`,
  PLAN_BUILDER: '/plan',
  NXT_LEVEL: '/nxt-level',
  CHAT: '/chat',
  CHAT_WITH_BOT: (botId: string) => `/chat/${botId}`,
  BLOG: '/blog',
  BLOG_POST: (slug: string) => `/blog/${slug}`,
  TERMS: '/terms',
  CONTACT: '/contact',
  ADMIN: {
    ROOT: '/admin',
    DASHBOARD: '/admin',
    USERS: '/admin/users',
    USER_DETAIL: (id: string) => `/admin/users/${id}`,
    ROLES: '/admin/roles',
    ROLE_DETAIL: (id: string) => `/admin/roles/${id}`,
    ROLE_CREATE: '/admin/roles/new',
    ROLE_ASSIGN: (id: string) => `/admin/roles/${id}/assign`,
    ASSIGN_USER_ROLES: '/admin/roles/assign-users',
    MODULES: '/admin/modules',
    META_TAGS: '/admin/meta-tags',
    META_TAG_DETAIL: (id: string) => `/admin/meta-tags/${id}`,
    // Bots
    BOTS: '/admin/bots',
    BOT_CREATE: '/admin/bots/new',
    BOT_DETAIL: (id: string) => `/admin/bots/${id}`,
    BOTS_CONFIG: '/admin/bots/config',
    // Knowledge Bases
    KNOWLEDGE_BASES: '/admin/knowledge-bases',
    KNOWLEDGE_BASES_CONFIG: '/admin/knowledge-bases/config',
    KNOWLEDGE_BASE_CREATE: '/admin/knowledge-bases/new',
    KNOWLEDGE_BASE_DETAIL: (id: string) => `/admin/knowledge-bases/${id}`,
    // Knowledge Graph
    KNOWLEDGE_GRAPH: '/admin/knowledge-graph',
    KNOWLEDGE_GRAPH_EXPLORER: '/admin/knowledge-graph/explorer',
    // Marketing
    MARKETING: '/admin/marketing',
    // System (Configuration)
    SYSTEM: '/admin/system',
    // Tracking
    TRACKING: '/admin/tracking',
    // Monitoring
    MONITORING: '/admin/monitoring',
    // Queues (Bull Board)
    QUEUES: '/admin/queues',
    // Logs
    LOGS: '/admin/logs',
    // Support
    SUPPORT: '/admin/support',
    SUPPORT_CONVERSATION: (id: string) => `/admin/support/${id}`,
    // Inquiries
    INQUIRIES: '/admin/inquiries',
    // Blog
    BLOG: '/admin/blog',
    BLOG_TOPICS: '/admin/blog/topics',
    BLOG_ARTICLES: '/admin/blog/articles',
    BLOG_ARTICLE_NEW: '/admin/blog/articles/new',
    BLOG_ARTICLE_EDIT: (id: string) => `/admin/blog/articles/${id}/edit`,
    BLOG_PRESETS: '/admin/blog/presets',
    BLOG_INTEGRATIONS: '/admin/blog/integrations',
    BLOG_AUDIT_POLICIES: '/admin/blog/audit-policies',
    // Products
    PRODUCTS: '/admin/products',
    PRODUCT_DETAIL: (id: string) => `/admin/products/${id}`,
    PRODUCT_ONEPAGER: (id: string) => `/admin/products/${id}/onepager`,
    // Product Planner
    PRODUCT_PLANNER: '/admin/product-planner',
    // Stores (Shopify)
    STORES: '/admin/stores',
    STORE_DETAIL: (id: string) => `/admin/stores/${id}`,
    // Digital Assets
    DIGITAL_ASSETS: '/admin/digital-assets',
    DIGITAL_ASSET_DETAIL: (id: string) => `/admin/digital-assets/${id}`,
    DIGITAL_ASSET_CREATE: '/admin/digital-assets/new',
    // Ecommerce Settings
    ECOMMERCE_SETTINGS: '/admin/ecommerce/settings',
    // Ecommerce Analytics
    ECOMMERCE_ANALYTICS: '/admin/ecommerce/analytics',
    // Ecommerce Observability
    OBSERVABILITY: '/admin/ecommerce/observability',
    // Orders
    ORDERS: '/admin/orders',
    ORDERS_KANBAN: '/admin/orders/kanban',
    ORDER_DETAIL: (id: string) => `/admin/orders/${id}`,
    // Social Media
    SOCIAL_MEDIA: '/admin/social-media',
    // Corporate Brain
    CORPORATE_BRAIN: '/admin/corporate-brain',
    CORPORATE_DOCS: '/admin/corporate-docs',
  },
  // Public routes (no auth required)
  PUBLIC: {
    ADDRESS_CORRECTION: '/address-correction/:token',
  },
  // Storefront (Shop) - all routes include storeSlug
  SHOP: {
    ROOT: (storeSlug: string) => `/shop/${storeSlug}`,
    PRODUCTS: (storeSlug: string) => `/shop/${storeSlug}/products`,
    PRODUCT_DETAIL: (storeSlug: string, handle: string) => `/shop/${storeSlug}/products/${handle}`,
    PRODUCT_LANDING: (storeSlug: string, handle: string) => `/shop/${storeSlug}/products/${handle}/landing`,
    COLLECTIONS: (storeSlug: string) => `/shop/${storeSlug}/collections`,
    COLLECTION_DETAIL: (storeSlug: string, handle: string) => `/shop/${storeSlug}/collections/${handle}`,
    SEARCH: (storeSlug: string) => `/shop/${storeSlug}/search`,
    CART: (storeSlug: string) => `/shop/${storeSlug}/cart`,
  },
} as const;







